import { IconProps } from "../../utils/global-types/global-types";

const StrikeThroughIcon = ({ className, ...rest }: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 18 18"
      className={className ? className : "w-[18px] h-[18px]"}
      {...rest}
    >
      <g fill="currentColor" clipPath="url(#clip0_9118_142248)">
        <path d="M15.534 9a.7.7 0 0 0-.7-.7H3.167a.7.7 0 0 0 0 1.4h11.667a.7.7 0 0 0 .7-.7M9 3.867a2.314 2.314 0 0 1 2.289 1.776.7.7 0 1 0 1.368-.286A3.71 3.71 0 0 0 9 2.467a3.68 3.68 0 0 0-3.733 3.616c0 .615.163 1.218.47 1.75h1.836a2.17 2.17 0 0 1-.906-1.75A2.28 2.28 0 0 1 9 3.867M9 14.133a2.314 2.314 0 0 1-2.288-1.776.7.7 0 1 0-1.369.286A3.71 3.71 0 0 0 9 15.533a3.68 3.68 0 0 0 3.733-3.616c0-.615-.162-1.218-.47-1.75h-1.836a2.17 2.17 0 0 1 .907 1.75A2.28 2.28 0 0 1 9 14.133"></path>
      </g>
      <defs>
        <clipPath id="clip0_9118_142248">
          <path fill="#fff" d="M2 2h14v14H2z"></path>
        </clipPath>
      </defs>
    </svg>
  );
};

export default StrikeThroughIcon;
